//export const  API_PATH= 'http://localhost/vignets_api/public/';
export const  API_PATH= 'http://ec2-52-66-77-130.ap-south-1.compute.amazonaws.com/apivignetsreact/public/';
//export const  API_PATH= 'https://vigapiv1.vignets.com/';
export const  IMG_PATH = 'https://s3cdn.vignets.com/';
export const  IMGIX_PATH = 'https://vignets.imgix.net/';
export const  BUILDER_PATH = 'https://agency.vignets.com/builder/?';
export const  PUB_PLAYER_PATH = 'https://a.vignets.com/player/';
export const  UNPUB_PLAYER_PATH = 'https://a.vignets.com/player/?';


export const  BUCKET_NAME = 'lexplainer';
export const  ALBUM_NAME = 'assets/slider';
export const  REGION = 'us-east-1';
export const  ACCESS_KEY_ID = 'AKIAIAEQKI43QMFTGF7A';
export const  SECRET_ACCESS_KEY = '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';


// WEBPACK FOOTER //
// ./src/constants/index.js